import { SvgIcon, SvgIconProps } from '@mui/material';
import React, { ReactElement } from 'react';

export interface SearchCircleProps extends SvgIconProps {}

export const SearchCircle = ({
  style,
  ...iconProps
}: SearchCircleProps): ReactElement => {
  style = {
    fontSize: '1em',
    ...style,
  };

  return (
    <SvgIcon
      style={style}
      {...iconProps}
      width="83"
      height="80"
      viewBox="0 0 83 80"
      fill="none"
    >
      <circle
        cx="42.836"
        cy="39.6231"
        r="38.6231"
        fill="white"
        stroke="#23305F"
        strokeWidth="2"
      />
      <circle
        cx="39.6231"
        cy="39.6231"
        r="38.6231"
        stroke="#5CDA64"
        strokeWidth="2"
      />
      <path
        d="M39.5 50.5C46.1274 50.5 51.5 45.1274 51.5 38.5C51.5 31.8726 46.1274 26.5 39.5 26.5C32.8726 26.5 27.5 31.8726 27.5 38.5C27.5 45.1274 32.8726 50.5 39.5 50.5Z"
        stroke="#23305F"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M56.1196 55.1196L47.9746 46.9746"
        stroke="#23305F"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};
